import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses, Bonus } from '../data/bonuses';
import { heroImage } from '../data/copy';
import { optimizedImage } from '../utils/image';

/** One mockup download serves every bonus cover, each cropped with CSS. */
const MOCKUP_URL = optimizedImage(heroImage, 1254, 70);
export function BonusesSection() {
  return <section id="bonuses" className="w-full scroll-mt-6 bg-slate-900 py-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:py-14 [.chalk_&]:bg-white" aria-labelledby="bonuses-heading" data-id="element-15" data-mp="qw5wrokyc7wx">
      <div className="mx-auto max-w-5xl px-6" data-id="element-16" data-mp="1eje2g7malizh">
        <SectionHeading eyebrow="Included free" title={<span id="bonuses-heading" data-id="element-18" data-mp="1el8booo7bmnq">+ 5 practical coaching bonuses</span>} lead="Tools designed to solve real problems before and during practice." data-id="element-17" data-mp="1eicgv97nhe3i" />

        <ul className="mt-8 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-19" data-mp="1nl3rx7wm67um">
          {bonuses.map((bonus, index) => {
          const isLastOdd = index === bonuses.length - 1 && bonuses.length % 2 === 1;
          return <BonusCard key={bonus.number} bonus={bonus} className={isLastOdd ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.5rem)]' : ''} data-id="element-20" data-mp="3prn5w0zy1f4d" data-mpi={index} />;
        })}
        </ul>
      </div>
    </section>;
}
interface BonusCardProps {
  bonus: Bonus;
  className?: string;
}

/** Cover (cropped from the product mockup) on the left, details on the right. */
function BonusCard({
  bonus,
  className = ''
}: BonusCardProps) {
  const {
    x,
    y,
    w,
    h
  } = bonus.crop;
  return <li className={`flex min-h-[11rem] overflow-hidden rounded-2xl border border-slate-800 bg-slate-950 [.chalk_&]:border-slate-200 [.chalk_&]:bg-slate-50 ${className}`} data-id="element-21" data-mp="gl5cpsky1jvr">
      <div className="flex w-[36%] max-w-[10rem] shrink-0 items-center justify-center bg-slate-800 p-2.5 [.chalk_&]:bg-slate-100" data-id="element-22" data-mp="leg90zs4qi9f">
        <div role="img" aria-label={`${bonus.title} cover`} className="w-full rounded-md" style={{
        aspectRatio: `${w} / ${h}`,
        backgroundImage: `url("${MOCKUP_URL}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${100 / w}% ${100 / h}%`,
        backgroundPosition: `${x / (1 - w) * 100}% ${y / (1 - h) * 100}%`
      }} data-id="element-23" data-mp="vatd8rlaweif" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col border-l-[3px] px-3.5 py-3 sm:px-4 sm:py-3.5" style={{
      borderColor: bonus.color
    }} data-id="element-24" data-mp="5kb7ktn93hgi">
        <div className="flex items-center gap-2" data-id="element-25" data-mp="fjah0efubh4k">
          <span className="rounded px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-[0.14em] text-slate-950" style={{
          backgroundColor: bonus.color
        }} data-id="element-26" data-mp="fih5l05xs3g3">
            Bonus {bonus.number}
          </span>
          <span className="rounded-full bg-orange-500 px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-[0.12em] text-slate-950" data-id="element-27" data-mp="13afwgshvc7ec">
            Free
          </span>
        </div>
        <h3 className="mt-1 text-base font-extrabold uppercase leading-[1.1] tracking-tight text-slate-50 sm:text-lg [.chalk_&]:text-slate-900" data-id="element-28" data-mp="3519i9xig9kus">
          {bonus.title}
        </h3>
        {bonus.intro ? <p className="mt-1 text-[0.82rem] leading-snug text-slate-50/90 [.chalk_&]:text-slate-900/90" data-id="element-29" data-mp="1fk5ja5u73rpr">{bonus.intro}</p> : null}
        {bonus.items ? <p className="mt-1 text-[0.78rem] leading-snug text-slate-400 [.chalk_&]:text-slate-600" data-id="element-30" data-mp="1ki72qrvj9t1r">
            {bonus.listLabel ? <span className="font-semibold text-slate-50/80 [.chalk_&]:text-slate-900/80" data-id="element-31" data-mp="15tszwgy4a4l7">{bonus.listLabel} </span> : null}
            {bonus.items.join(' · ')}
          </p> : null}
        <p className="mt-auto pt-1.5 text-[0.8rem] font-semibold leading-snug text-orange-400 [.chalk_&]:text-orange-600" data-id="element-32" data-mp="wsl72eeddvyi">
          {bonus.closingLabel ? `${bonus.closingLabel} ` : ''}
          {bonus.closing.join(' ')}
        </p>
      </div>
    </li>;
}